import { GraphViewType } from '../../components/types';
import { LegacySaveData, SaveData } from '../useSavedNodePositions';
const convertLegacySaveToNewSave = (legacyData: LegacySaveData): SaveData => {
  return {
    lastUsedGraphType: GraphViewType.mesh,
    [GraphViewType.mesh]: legacyData,
  };
};
export default convertLegacySaveToNewSave;
